<div class="rebate">
	<h3 *ngIf="rebate.pdf"><a [href]="rebate.pdf.url" target="_blank" class="{{rebate.pdf.ext.substring(1)}}">{{rebate.title}}</a></h3>
	<h3 *ngIf="!rebate.pdf">{{rebate.title}}</h3>
	<div class="button-holder"><div class="button"><a [href]="rebate.pdf.url" target="_blank">Download</a></div></div>
</div>
